module.exports = __webpack_public_path__ + "img/pop-up-bezar-ikon.a6069f11.svg";